<template>
  <h3 class="mb-5">Blacklisted vouchers</h3>
  <p class="mb-2">
    This is a list of vouchers that can no longer be used. To add a voucher to
    the blacklist, search the code and add to the blacklist.
  </p>
  <SoAlert
    v-if="blacklistedCodes.isError"
    title="Failed to render blacklisted vouchers"
  />
  <SoDataTable
    v-else
    ref="blacklisted-table"
    class="mb-5"
    :loading="blacklistedCodes.isFetching"
    :headers="blacklistedTableHeaders"
    :items="list"
    :has-pagination="list.length > 10"
    searchable
    row-clickable
    data-testid="blacklisted-referrals-table"
    @click:row="viewCode"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { ReferralService } from "@/services/operations/ReferralService"
  import SoDataTable from "@/components/dataTable/SoDataTable.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import {
    SoDataTableHeader,
    SoDataTableItem,
  } from "@/types/components/SoDataTable"
  import { RouteNames } from "@/types/router"

  const blacklistedTableHeaders: SoDataTableHeader[] = [
    {
      title: "Code",
      key: "code",
    },
    {
      title: "CC Number",
      key: "customerNumber",
    },
    {
      title: "Owner Account Number",
      key: "accountNumber",
    },
    {
      title: "Email",
      key: "email",
    },
  ]

  export default defineComponent({
    components: {
      SoAlert,
      SoDataTable,
    },
    data() {
      return {
        blacklistedTableHeaders,
      }
    },
    computed: {
      blacklistedCodes() {
        return ReferralService.getBlacklistedCodes()
      },
      list() {
        return this.blacklistedCodes.data.map((codeObj) => ({
          ...codeObj,
          code: codeObj.code,
        }))
      },
    },
    methods: {
      viewCode(referral: SoDataTableItem) {
        this.$router.push({
          name: RouteNames.AdminReferralCode,
          params: { referralCode: referral.code as string },
        })
      },
    },
  })
</script>
